const lodash = require('lodash');
const React = require('react');
const Highcharts = require('highcharts');
const HighchartsReact = require('highcharts-react-official');
const createReactClass = require("create-react-class");

require('../plugins/Graylog.jsx')(Highcharts);
require('../plugins/NoData.js')(Highcharts);
require('../plugins/Boost.js')(Highcharts);

/**
 * If updating this variable, ensure you also update the SCSS file for metrics
 * as Highcharts won't use these for the series in styled mode
 * @type {{colors: string[]}}
 */
const theme = {
  colors: ['#3BAFFA', '#0273BD', '#4CAF50', '#F44336',
    '#94DEA9', '#FF5722', '#FFC107', '#9C27B0', '#009688', '#795548',
    '#3F51B5', '#607D8B', '#673AB7']
};

/**
 * Some Grafana data types require manual work applied to them in order to format them. These
 * are the ones that are returned by our metrics
 */
const grafanaUnits = {
  'kbytes': 1024,
  'bytes': 1,
  'ms': 1,
  'µs': 1
};

// Apply the theme
Highcharts.setOptions(theme);

/**
 * This panel renders a Highchart object using the series data obtained via AJAX
 */
const GraphPanel = createReactClass({
  getInitialState() {
    // For data being formatted using a callback function, override it here
    for (let i = 0; i < this.props.item.data.yAxis.length; i++) {
      const type = this.props.item.data.yAxis[i].grafanaType;

      if (grafanaUnits.hasOwnProperty(type)) {
        this.props.item.data.yAxis[i].labels =  this.props.item.data.yAxis[i].labels || {};
        this.props.item.data.tooltip =  this.props.item.data.tooltip || {};

        const multiplier = grafanaUnits[type];

        let formatter = (value) => {
            if (type === 'ms' || type === 'µs') {
               return this.formatMilliseconds(value);
            } else {
                return this.formatBytes(value * multiplier);
            }
        };

        this.props.item.data.yAxis[i].labels.formatter = (chart) => {
          return formatter(chart.value);
        };
        this.props.item.data.tooltip.formatter = function() {
          return "<b>"+ this.series.name+"</b>: "+ formatter(this.y);
        };
      }
    }

    return {
      item: this.props.item,
      lastUpdated: null
    };
  },

  componentDidMount() {
    this.refreshChart();
  },

  shouldComponentUpdate(nextProps, nextState) {
    // Only trigger a re-render if the chart parameters have changed to speed up changing dashboards/rows
    return this.state.lastUpdated !== nextState.lastUpdated ||
        nextProps.timeRange !== this.props.timeRange ||
        nextProps.showDeployments !== this.props.showDeployments ||
        nextProps.showVirtualStacks !== this.props.showVirtualStacks;
  },

  componentDidUpdate(prevProps) {
    if (prevProps.timeRange !== this.props.timeRange ||
        prevProps.showVirtualStacks !== this.props.showVirtualStacks) {
      this.refreshChart();
    }

    if (prevProps.showDeployments !== this.props.showDeployments) {
      this.toggleDeployments();
    }
  },

    /**
     * Helper method to scale the number of bytes into a human-readable version
     * @param bytes
     * @returns {string}
     */
    formatBytes(bytes) {
        if (bytes === 0) return '';
        var s = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
        var e = Math.floor(Math.log(bytes) / Math.log(1024));
        var value = ((bytes / Math.pow(1024, Math.floor(e))).toFixed(2));
        e = (e < 0) ? (-e) : e;
        value += ' ' + s[e];
        return value;
    },

    /**
     * Helper method to scale the number of milliseconds into a human-readable version
     * @param milliseconds
     * @returns {string}
     */
    formatMilliseconds(milliseconds) {
        if (milliseconds === 0 || typeof milliseconds === 'undefined') return '';
        var s = ['ms', 's', 'min', 'hr', 'day'];
        var e = Math.floor(Math.log(milliseconds) / Math.log(1000));
        var value = ((milliseconds / Math.pow(1000, Math.floor(e))).toFixed(0));
        e = (e < 0) ? (-e) : e;
        value += s[e];
        return value;
    },

  /**
   * Moves the chart into a loading state and fetches the latest series data from the server
   */
  refreshChart() {
    this.chart = this.refs.chart.chart;
    this.chart.hideNoData();
    this.chart.showLoading();
    const self = this;

    Q($.ajax({
      type: "POST",
      url: self.props.model.ChartUrl + '/' + self.state.item.id,
      data: {
        time: this.props.timeRange,
        maxDataPoints: this.chart.plotWidth,
        includeVirtualStacks: this.props.showVirtualStacks
      }
    }))
    .then(function (data) {
      const newData = self.state.item;
      newData.data.series = data;
      newData.data.xAxis = { type: 'datetime' };

      self.chart.hideLoading();
      self.chart.hideNoData();

      self.setState({
        item: newData,
        lastUpdated: new Date()
      });

    }).fail(function (e) {
      self.chart.hideLoading();
      self.chart.showNoData("Sorry, there was an error while loading your metrics");
    });
  },

  /**
   * If the stack has any deployments, this function will draw vertical lines on the graph to represent each
   * deployment. These lines are clickable and open the deployment modal window
   */
  toggleDeployments() {
    const self = this;
    self.refs.chart.chart.xAxis[0].removePlotLine('deployment');

    if (this.props.showDeployments) {
      lodash.map(this.props.model.Deployments, function(name, index) {
        self.refs.chart.chart.xAxis[0].addPlotLine({
          value: (index * 1000),
          className: 'highcharts-plotline-' + name[1].toLowerCase(),
          width: 2,
          id: 'deployment',
          events: {
            click: function() {
              window.location.href = self.props.model.DeploymentUrl + '/' + name[0];
            }
          }
        });
      });
    }
  },

  render: function() {
    const panelWidth = Math.floor(this.state.item.data.gridPos.w / 2);

    return (
      <div className={"metric-panel metric-graph-panel col-sm-" + panelWidth}>
        <HighchartsReact
          ref={'chart'}
          highcharts={Highcharts}
          options={this.state.item.data}
          update={false}
        />
      </div>
    );
  }
});

module.exports = GraphPanel;
